import { cva } from 'class-variance-authority'
import type { FC } from 'react'
import { memo } from 'react'

import { Tooltip } from '../../../overlays/Tooltip/base/Tooltip'

import { TopNavbarProvider } from './TopNavbar.context'
import type { TopNavbarProps } from './TopNavbar.types'
import { TopNavbarDropdownItem } from './compound/TopNavbarDropdownItem/TopNavbarDropdownItem'
import { TopNavbarItem } from './compound/TopNavbarItem/TopNavbarItem'
import { TopNavbarLeft } from './compound/TopNavbarLeft/TopNavbarLeft'
import { TopNavbarLogo } from './compound/TopNavbarLogo/TopNavbarLogo'
import { TopNavbarMiddle } from './compound/TopNavbarMiddle/TopNavbarMiddle'
import { TopNavbarNotification } from './compound/TopNavbarNotification/TopNavbarNotification'
import { TopNavbarRight } from './compound/TopNavbarRight/TopNavbarRight'

const topNavbarCVA = {
  root: cva([
    'flex aspect-auto h-12 w-full flex-row justify-between gap-2 bg-neutral-800 px-4 py-2'
  ])
}

export const BaseTopNavbar: FC<TopNavbarProps> = memo(
  ({ className, showDropdownBelowBreakpoint, children, ...other }) => {
    return (
      <TopNavbarProvider value={{ showDropdownBelowBreakpoint }}>
        <Tooltip.Group>
          <div {...other} className={topNavbarCVA.root({ className })}>
            {children}
          </div>
        </Tooltip.Group>
      </TopNavbarProvider>
    )
  }
)

type CompoundTopNavbarType = {
  Left: typeof TopNavbarLeft
  Middle: typeof TopNavbarMiddle
  Right: typeof TopNavbarRight
  Logo: typeof TopNavbarLogo
  Item: typeof TopNavbarItem
  Notification: typeof TopNavbarNotification
  DropdownItem: typeof TopNavbarDropdownItem
}

const TypedTopNavbar = BaseTopNavbar as typeof BaseTopNavbar &
  CompoundTopNavbarType

TypedTopNavbar.displayName = 'TopNavbar'
TypedTopNavbar.Left = TopNavbarLeft
TypedTopNavbar.Middle = TopNavbarMiddle
TypedTopNavbar.Right = TopNavbarRight
TypedTopNavbar.Logo = TopNavbarLogo
TypedTopNavbar.Item = TopNavbarItem
TypedTopNavbar.Notification = TopNavbarNotification
TypedTopNavbar.DropdownItem = TopNavbarDropdownItem

export const TopNavbar = TypedTopNavbar

export type { TopNavbarProps } from './TopNavbar.types'
